/**
 * Zips 2 arrays together
 * @param {Array} array1
 * @param {Array} array2
 * @return {Array}
 */
export function zip(array1, array2) {
  return array1.map((item, index) => [item, array2[index]]);
}

/**
 * Evaluates if a string can mean "All".
 * for a specific context.
 * @param {string} string
 * @return {boolean}
 */
export function isAll(string) {
  const allTokens = ["All", "all", "الكل", "", undefined, null];
  return allTokens.includes(string);
}
